import { render, staticRenderFns } from "./LKAsideMenu.vue?vue&type=template&id=a83a92b4&"
import script from "./LKAsideMenu.vue?vue&type=script&lang=js&"
export * from "./LKAsideMenu.vue?vue&type=script&lang=js&"
import style0 from "./LKAsideMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VMenu})
